import React from 'react';
import styled from 'styled-components';

import StyledLink from '@makeship/core/lib/components/Link';
import { Caption, H1Styles, H4, H5, P2, S1, Strong } from '../Typography';

const ShippingDestinationsContainer = styled.div`
  padding: 16px;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    padding: 48px;
  }
`;

const Heading = styled(H4)`
  margin-bottom: 30px;
  margin-top: 16px;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    margin-bottom: 48px;
    ${H1Styles}
  }
`;

const ShippingBody = styled(P2)`
  margin: 24px 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const ShippingFooter = styled(P2)`
  margin-top: 24px;
`;

const ShippingDestinations: React.FC = () => (
  <ShippingDestinationsContainer>
    <Heading>SHIPPING DETAILS</Heading>
    <H5>⭐️ We ship worldwide!* ⭐️</H5>
    <Caption>*with some exceptions.</Caption>
    <ShippingBody>
      <P2>
        On average, <Strong>we ship within 7-15 days after production is complete.</Strong> There are some exceptions
        where it may take 10-30 days.
      </P2>
    </ShippingBody>
    <div>
      <ShippingBody>
        <P2>
          Also, <Strong>there are some countries/regions we do NOT ship to</Strong> due to delivery restrictions and
          global situations.
        </P2>
        <P2>
          As this list of countries/regions is ever changing, we recommend adding a product into your cart, selecting
          &quot;Checkout&quot; and entering your address in the following checkout page. Don&apos;t worry! You will not
          be forced into making a purchase (unless you want to 😉). Here you will get the most up to date shipping
          information for your specific country!
        </P2>
      </ShippingBody>
    </div>

    <ShippingFooter>
      If you still have any questions, please visit our{' '}
      <StyledLink.Primary
        href="https://makeshiphelp.zendesk.com/hc/en-us"
        target="_blank"
        rel="noopener noreferrer"
        title=" Makeship Help Center"
      >
        Makeship Help Center
      </StyledLink.Primary>{' '}
      or{' '}
      <StyledLink.Primary
        href="https://makeshiphelp.zendesk.com/hc/en-us/requests/new"
        target="_blank"
        rel="noopener noreferrer"
        title="Submit a Support Ticket"
      >
        Submit a Support Ticket
      </StyledLink.Primary>{' '}
      so we can help you!
    </ShippingFooter>
  </ShippingDestinationsContainer>
);

export default ShippingDestinations;
